<template>
  <div class="apply">
    <div class="box-card">
      <div class="head">
        <span class="applyTitle">{{ $t("navbar.lintel") }}</span>
        <span class="applyEnd">{{
          $t("common.tishi", { time: "2023年9月20日" })
        }}</span>
      </div>

      <div class="introduce">
        <div class="shuoMing">{{ $t("common.explain") }}</div>
        <div class="box">
          <div class="txt">{{ $t("lintel.explain1") }}</div>
          <div class="txt">{{ $t("lintel.explain2") }}</div>
          <div class="txt">{{ $t("lintel.explain3") }}</div>
        </div>
      </div>

      <div class="instance">
        <p class="title">{{ $t("lintel.living") }}</p>
        <div class="img">
          <img src="../../../static/hk_bg.png" alt="" />
          <div class="backTxt">
            <div class="topText">
              <span class="companyName">{{ $t("lintel.companyName") }}</span>
              <span class="number">{{ $t("homepage.positionNumber") }}</span>
            </div>
            <div class="topText">
              <span class="EcompanyName">COMPANY NAME</span>
              <span class="Enumber">Booth No.</span>
            </div>
          </div>
        </div>

        <div class="content">
          <el-form :model="fromInfo" ref="fromInfo" label-width="200px">
            <el-form-item
              :label="$t('lintel.uniteNameCh') + '：'"
              prop="companyNameC"
              :rules="[{ required: true }]"
              maxlength="50"
              show-word-limit
            >
              <span>{{ fromInfo.companyNameC }}</span>
            </el-form-item>

            <el-form-item
              :label="$t('lintel.uniteNameEn') + '：'"
              prop="companyNameE"
              :rules="[{ required: true, message: $t('lintel.rulesMessage') }]"
              maxlength="50"
              show-word-limit
            >
              <el-input
                type="age"
                v-model="fromInfo.companyNameE"
                autocomplete="off"
                :placeholder="$t('lintel.placeholder1')"
                @keyup.native="proving"
                :disabled="flag == 2 || flag == 0 ? true : false"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>

            <el-form-item
              :label="$t('homepage.positionNumber') + '：'"
              prop="boothNum"
              :rules="[{ required: true }]"
            >
              <el-select
                v-model="fromInfo.boothNum"
                :placeholder="$t('common.select')"
                @change="changeSelect(fromInfo.boothNum)"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              :label="$t('lintel.tishi')"
              label-width="500px"
              class="msg"
              :rules="[{ required: true }]"
            >
              <span class="telNumber">{{ $t("lintel.iphone") }}</span>
            </el-form-item>

            <!---------------按钮组----------------->
            <el-form-item>
              <div class="btn">
                <div class="why" v-if="flag === '-1'">
                  {{ $t("active.noPass")
                  }}<el-tooltip
                    class="item"
                    effect="dark"
                    :content="fromInfo.cause"
                    placement="top-start"
                  >
                    <router-link to="#">{{ $t("active.cause") }}</router-link>
                  </el-tooltip>
                </div>
                <!--     <el-button type="primary" @click="submitForm('fromInfo')" v-if="flag !== '2'">{{ $t('common.submit') }}</el-button>
                            <el-button type="primary" v-if="flag === '2'">{{$t('active.inreview')}}</el-button> 
                   -->

                <!---------------1是提交------------------->
                <el-button
                  type="primary"
                  @click="submitForm('fromInfo')"
                  v-if="flag == '1'"
                  >{{ $t("common.submit") }}</el-button
                >
                <!---------------2是审核中-------------------->
                <el-button type="primary" v-if="flag == '2'">{{
                  $t("active.inreview")
                }}</el-button>

                <!---------------0是审核中-------------------->
                <el-button type="primary" v-if="flag == '0'"
                  >{{ $t("active.approve") }}</el-button
                >

                <!---------------1是提交------------------->
                <el-button
                  type="primary"
                  @click="submitForm('fromInfo')"
                  v-if="flag == '-1'"
                  >{{ $t("common.submit") }}</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBooth } from "../../../../api/exhibitor.js";
import { getInit, submitBooth } from "../../../../api/lintel.js";
export default {
  data() {
    return {
      flag: "",
      currentId: "",
      options: [],
      value: "",
      input: "",
      //表单对象
      fromInfo: {
        companyNameC: "",
        companyNameE: "",
        boothNum: "",
        cause: "",
      },
      boothList: [],
    };
  },

  methods: {
    async changeSelect(id) {
      // 切换下拉框
      try {
        const params = {
          boothId: id,
        };
        const { data } = await getInit(params);
        this.fromInfo = data.data;
        this.flag = Number(this.fromInfo.auditFlag);
      } catch (err) {
        this.$message({
          type: "error",
          message: "获取当前展商的展位信息失败!",
        });
      }
    },
    // 初始化的时候拿到展位选择框下的第一条数据
    async getInitData() {
      try {
        const params = {
          boothId: this.currentId,
        };
        const { data } = await getInit(params);
        this.flag = data.data.auditFlag;
        this.fromInfo = data.data;
      } catch (err) {
        this.$message({
          type: "error",
          message: "获取当前展商的展位信息失败!",
        });
      }
    },
    // 获取当前展商的展位
    async getBoothLists() {
      try {
        const { data } = await getBooth();

        const arr = data.data;
        this.boothList = arr;
        arr.map((item) => {
          this.options.push({
            value: item.id,
            label: item.boothNum,
          });
        });
        this.currentId = arr[0].id;
        if (this.currentId !== "") {
          this.getInitData();
        }
      } catch (err) {
        this.$message({
          type: "error",
          message: "获取展位列表失败!",
        });
      }
    },
    //提交触发
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const currentBooth = this.boothList.filter(
            (it) => it.boothNum === this.fromInfo.boothNum
          );
          const params = {
            englishName: this.fromInfo.companyNameE,
            boothId: currentBooth[0].id,
          };
          try {
            const { data } = await submitBooth(params);
            if (data.code === 200) {
              this.$message({
                type: "success",
                message: "提交标摊门楣信息成功!",
              });
              this.flag === 2;
            }
          } catch (err) {
            this.$message({
              type: "error",
              message: "提交标摊门楣信息失败!",
            });
          }
        } else {
          return false;
        }
      });
    },
    //输入框重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //

    proving() {
      // this.fromInfo.companyNameE = this.fromInfo.companyNameE.replace(/[A-Z][a-z]+/g, '');
      this.fromInfo.companyNameE = this.fromInfo.companyNameE.replace('.', '');
    },
  },
  created() {
    if (!this.$route.query.userId) {
      this.$router.go(-1);
    }
    this.getBoothLists();
  },
};
</script>

<style scoped lang="scss">
.apply {
  // padding: 17px 26px;
  box-sizing: border-box;
  background: #f0f2f5;
  .box-card {
    width: 100%;
    border-radius: 2px;
    background: #ffffff;
    .head {
      padding: 17px 0px;
      border-bottom: 1px solid #e8e8e8;
      .applyTitle {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 24px;
        margin-left: 26px;
      }
      .applyEnd {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 17px;
        margin-left: 17px;
      }
    }

    //说明
    .introduce {
      margin: 26px 17px 0px 17px;
      padding-bottom: 10px;
      background: #f6f6f7;
      display: flex;
 
      padding-left: 65px;

      .shuoMing {
      
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff190c;
        padding-top: 9px;
      }

      .box {

        padding-left: 10px;
        .txt {
          box-sizing: border-box;
          position: relative;
          padding-top: 9px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
      }
    }

    //标题
    .instance {
      margin: 0px 17px 0px 17px;
      .title {
        padding: 35px 0px 9px 0px;
        border-bottom: 1px solid #e9e9e9;
      }
      .img {
        width: 100%;
        height: 207px;
        margin-top: 9px;
        position: relative;
        img {
          width: 100%;
          height: 207px;
        }
        .backTxt {
          width: 100%;
          height: 207px;
          position: absolute;
          top: 0px;
          left: 0px;
          .companyName {
            font-size: 31px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #006fb8;
            line-height: 43px;
            float: left;
            margin: 62px 0px 0px 47px;
          }
          .number {
            font-size: 31px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #006fb8;
            line-height: 43px;
            float: right;
            margin: 62px 47px 0px 0px;
          }

          .EcompanyName {
            font-size: 31px;

            float: left;
            margin-left: -125px;
            margin-top: 119px;
            font-size: 19px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 26px;
          }
          .Enumber {
            font-size: 31px;
            margin-right: -95px;
            margin-top: 119px;
            float: right;
            font-size: 19px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 26px;
          }
        }
      }
      .content {
        width: 50%;
        margin: 0 auto;
        padding-bottom: 117px;
        padding-top: 42px;
        .btn {
          padding-bottom: 30px;
          .why {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff190c;
            margin-bottom: 22px;
            a {
              margin-left: 10px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #006fb8;
            }
          }
        }
        .telNumber {
          color: #006fb8;
          margin-left: 5px;
        }
      }
    }
  }
}
</style>

<style scoped>
/* .el-form >>> .el-form-item {
  margin-bottom: 2px;
}
.el-form >>> .el-input__inner {
  height: 24px;
  line-height: 24px;
  width: 540px;
} */
.el-form >>> .el-form-item__label {
  line-height: 12px;
  padding: 0px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 7px;
}
.el-form >>> .el-form-item__content {
  line-height: 28px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.el-form >>> .el-form-item {
  margin-bottom: 17px;
}
.el-form >>> .el-input {
  width: 468px;
}
.el-form >>> .el-input__inner {
  width: 468px;
  height: 28px;
  line-height: 28px;
}
.msg {
  margin-left: -55px;
}
.el-button--primary {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  min-width: 76px;
  height: 28px;
  line-height: 0px;
  background-color: #006fb8;
  text-align: center;
}
.el-form >>> .el-input__icon {
  line-height: 28px;
}
</style>
